var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "csv-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-531.000000, -1415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "csv-icon",
    transform: "translate(531.000000, 1415.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L10.552,0 L10.552,5.574 C10.552,6.6785695 11.4474305,7.574 12.552,7.574 L18,7.574 L18,18.92 C18,20.0245695 17.1045695,20.92 16,20.92 L2,20.92 C0.8954305,20.92 1.3527075e-16,20.0245695 0,18.92 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Shape",
    fill: "#44C0FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#80959D",
    fillRule: "nonzero",
    points: "12.1 0.669 12.1 6.007 17.445 6.007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47412109,17 L5.52734375,17 L3.95849609,14.7373047 L3.4765625,15.1303711 L3.4765625,17 L2.65966797,17 L2.65966797,12.0029297 L3.4765625,12.0029297 L3.4765625,14.3886719 C3.69987091,14.115233 3.92203666,13.852052 4.14306641,13.5991211 L5.49316406,12.0029297 L6.42285156,12.0029297 C5.55012584,13.0283254 4.92464382,13.7586241 4.54638672,14.1938477 L6.47412109,17 Z M9.20061199,17 L7.75139324,12.8266602 L7.72404949,12.8266602 C7.76278667,13.4464549 7.78215496,14.0275038 7.78215496,14.5698242 L7.78215496,17 L7.04045574,17 L7.04045574,12.0029297 L8.19231121,12.0029297 L9.58000652,15.9780273 L9.60051434,15.9780273 L11.0292253,12.0029297 L12.1844987,12.0029297 L12.1844987,17 L11.3983659,17 L11.3983659,14.5288086 C11.3983659,14.280435 11.4046321,13.9568705 11.4171647,13.5581055 C11.4296973,13.1593405 11.4405208,12.9178064 11.4496354,12.8334961 L11.4222917,12.8334961 L9.9218034,17 L9.20061199,17 Z M13.4070834,17 L13.4070834,12.0029297 L14.2239779,12.0029297 L14.2239779,16.2993164 L16.3397005,16.2993164 L16.3397005,17 L13.4070834,17 Z",
    id: "KML",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKml);
export default __webpack_public_path__ + "static/media/kml.208d6ea0100074e70dfd796ed2261e60.svg";
export { ForwardRef as ReactComponent };